export enum LabelTableColumn {
	NAME = 'name',
	UPC = 'upc',
	EDIT = 'edit',
	DELETE = 'delete',
}
